import { PostMethod } from '../../serviceHelper';

const getMethods = (service: 'workflow', controller: 'Workflow') => ({
	ContinueProcess: new PostMethod<any, any>({
		service,
		controller,
		method: 'ContinueProcess'
	}),
	GetFlowInfo: new PostMethod<null, any>({
		service,
		controller,
		method: 'GetFlowInfo'
	}),
	GetFlowHistory: new PostMethod<string, any>({
		service,
		controller,
		method: 'GetFlowHistory'
	}),
	GetFlowDocuments: new PostMethod<string, any>({
		service,
		controller,
		method: 'GetFlowDocuments'
	}),
	GetFlowProperties: new PostMethod<string, any>({
		service,
		controller,
		method: 'GetFlowProperties'
	}),
	GetFlowRequestEvents: new PostMethod<string, any>({
		service,
		controller,
		method: 'GetFlowRequestEvents'
	}),
	GetProcessRequestEvents: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetProcessRequestEvents'
	}),
	GetProcessRequestDocuments: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetProcessRequestDocuments'
	})
});

export { getMethods };
